import 'dom-slider';
const { slideToggle } = window.domSlider

const siteHeader = document.querySelector('.site-header');
const hamburger = document.querySelector('.site-header__hamburger');
const quoteDropdownBtn = document.querySelector('.quote-dropdown .button');

const initNavigation = () => {
  siteHeader.addEventListener('click', (e) => {
    const target = e.target;

    /*
    |--------------------------------------------------------------------------
    | Mobile nav and quote dropdown visibility
    |--------------------------------------------------------------------------
    */
    if (target === quoteDropdownBtn || target === hamburger) {
      let quoteDropdownOpen, mobileNavOpen;

      // Quote dropdown
      if (target === quoteDropdownBtn) {

        // Close the main menu if it's open
        document.body.classList.remove('menu-open');

        // Toggle visibility of the quote dropdown
        quoteDropdownOpen = document.body.classList.toggle('quote-dropdown-open');
      }

      // Main nav
      if (target === hamburger) {

        // Close the quote dropdown if it's open
        document.body.classList.remove('quote-dropdown-open');

        // Toggle visibility of the main menu dropdown
        mobileNavOpen = document.body.classList.toggle('menu-open');
      }

      // Add/remove overlay to the body if either of the above are still open
      if (mobileNavOpen || quoteDropdownOpen) {
        document.body.classList.add('show-overlay');
      } else {
        document.body.classList.remove('show-overlay');
      }
    }

    /*
    |--------------------------------------------------------------------------
    | Mobile nav - sub-nav dropdowns
    |--------------------------------------------------------------------------
    */
    if (target.classList.contains('js-mobile-menu-expand')) {
      const parentMenuItem = target.parentElement;
      const subNavItems = target.nextElementSibling;

      if (!subNavItems || !parentMenuItem) {
        return;
      }

      // Prevent further clicks until complete
      target.classList.add('pointer-events-none');

      // Toggle active on the <li>
      parentMenuItem.classList.toggle('is-active')

      console.log(subNavItems);

      // Reveal the sub-nav
      slideToggle({
        element: subNavItems,
        slideSpeed: 350,
        easing: 'ease-in-out',
      }).then(() => {
        // Then allow interaction
        target.classList.remove('pointer-events-none');
      });

    }
  });
}

export default initNavigation;